import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';
import {HoSoFile} from './hosofile';
export  class HoSo implements Deserializable
{
  public  id: number;
  public  ngayTao: string;
  public  ngayKetThuc: string;
  public  beLongTo: number;
  public  tenHoSo: string;
  public  quaTrinhXuLy: string;
  public  trangThai: number;
  public  nguoiTao: Staffs;
  public  hoSoFiles: HoSoFile[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nguoiTao = input.nguoiTao != null ? new Staffs().deserialize(input.nguoiTao): null;
    this.hoSoFiles = input.hoSoFiles != null? input.hoSoFiles.map(hoSoFiles => new HoSoFile().deserialize(hoSoFiles)): [];
    return this;
  }
}
